export const roadMapQuestions: { question: string; options: string[]; questionNumber: number }[] = [
  {
    //0 Region_location->1
    question: 'Where do you want to work?',
    options: ['≤30 min', '≤60 min', 'Transit', 'Car', 'Bike/Walk'],
    questionNumber: 1,
  },
  {
    //1 motivation_vector ->2
    question: 'What matters most to you in a job right now?',
    options: [
      'Higher pay',
      'Stable schedule',
      'Helping people',
      'Learning & growth',
      'Hands-on work',
      'Working outdoors',
    ],
    questionNumber: 2,
  },
  {
    //2 workstyle_vector->2
    questionNumber: 3,
    question: 'Which work rhythm fits you better?',
    options: ['Predictable routines', 'Mix of tasks', 'Fast-paced shifts', 'Project-based sprints'],
  },
  {
    //3 digital_literacy_score-> 3
    questionNumber: 4,
    question: 'Comfort with digital tools?',
    options: [],
  },
  {
    //4 tool_exposure_vector-> 4
    questionNumber: 5,
    question: 'Which tech/tools have you used?',
    options: [
      'Warehouse scanners',
      'EMR apps',
      'Ticketing systems',
      ' Power/hand tools',
      'Scheduling apps',
      'Not Applicable',
    ],
  },
  {
    //5 sector_interest_vector-> 5
    questionNumber: 6,
    question: 'Which task feels most natural?',
    options: [
      'Helping customers',
      'Stocking',
      'Assembling',
      'Caring',
      'Troubleshooting',
      'Green projects',
    ],
  },
  {
    //6 scenario_people_vector->6
    questionNumber: 7,
    question: 'An upset customer/patient approaches you. First move?',
    options: [
      'De-escalate calmly',
      'Clarify need & set expectations',
      'Follow protocol/script',
      'Call for help',
    ],
  },
  {
    //7 scenario_ops_vector-> 7
    questionNumber: 8,
    question: 'A line backs up / device fails / rooftop hazard. First move?',
    options: [
      'Check process/queue',
      'Diagnose tool/device',
      'Stop work & address safety',
      'Escalate & document',
    ],
  },
  {
    //8 role_alignment_vector-> 8
    questionNumber: 9,
    question: 'Which of these tasks do you prefer?',
    options: [
      'Explaining',
      ' Lifting boxes',
      'Fixing equipment',
      'Monitoring patients',
      'Configuring device',
      'Installing solar',
    ],
  },
  {
    //9 problem_style_vector-> 8
    questionNumber: 10,
    question: 'What do you do first if something goes wrong?',
    options: ['Calm person', 'Check process', 'Diagnose tool', 'Escalate', 'Safer workaround'],
  },
  {
    //10 detail_orientation_flag-> 8
    questionNumber: 11,
    question: 'What if you see a data error?',
    options: ['Fix & log', 'Alert supervisor', 'Flag & keep moving', 'Investigate'],
  },
  {
    //11 PhysicalityScore ->9
    questionNumber: 12,
    question: 'Comfort with physical roles?',
    options: [],
  },
  {
    //12 FacilityEnvironment ->9
    questionNumber: 13,
    question: 'Comfort around machines/sites?',
    options: [],
  },
  {
    //13 CustomerInteraction ->9
    questionNumber: 14,
    question: 'Comfort face-to-face with customers/patients?',
    options: [],
  },
  {
    //14 StructurePreference ->10
    questionNumber: 15,
    question: 'Do you prefer clear protocols or improvising?',
    options: ['Protocols', 'Mix', 'Improvising'],
  },
  {
    //15 Availability ->11
    questionNumber: 16,
    question: 'Which schedules are okay?',
    options: ['Evenings', 'Weekends', 'Rotating', 'No nights', 'No weekends'],
  },
  {
    //16 certs_vector-> 12
    questionNumber: 17,
    question: 'Any certifications?',
    options: [
      'OSHA-10',
      'CompTIA A+',
      'CPR/First Aid',
      'Forklift',
      'Solar install',
      'Not Applicable',
    ],
  },
  {
    //17 green_orientation_score-> 13
    questionNumber: 18,
    question: 'How important is sustainability?',
    options: [],
  },
  {
    //18 StructuredContext ->14
    questionNumber: 19,
    question: 'Bilingual',
    options: ['Yes', 'No'],
  },
  {
    //19 StructuredContext ->14
    questionNumber: 20,
    question: 'Reliable transportation',
    options: ['Yes', 'No'],
  },
  {
    //20 StructuredContext ->14
    questionNumber: 21,
    question: 'Caregiving duties',
    options: ['Yes', 'No'],
  },
  {
    //21 Context_notes ->15
    questionNumber: 22,
    question: 'Anything else we should know?',
    options: [],
  },
];
